import React from 'react';
import { Button, Modal } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { rethinkListPath } from '../../../helpers/rethink_helper';

type Props = {
  rethinkInstanceUrl: string,
  rethinkListId: string,
  onHide: () => void
}

export default function RethinkSyncModalComplete(
  { rethinkInstanceUrl, rethinkListId, onHide }: Props
) {

  return (
    <>
      <Modal.Header closeButton>
        <h5 className="mb-0">Exporting Complete</h5>
      </Modal.Header>
      <Modal.Body>
        <div>
          Property and owner contact data have been exported to Rethink.
          Click below to view the list.
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={onHide}>
          Close
        </Button>
        <Button
          className="d-flex align-items-center gap-2"
          href={rethinkListPath(rethinkInstanceUrl, rethinkListId)}
          rel="noopener noreferrer"
          target="_blank"
          variant="secondary"
        >
          <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
          <span>View in Rethink</span>
        </Button>
      </Modal.Footer>
    </>
  );
}
